module.exports = __webpack_public_path__ + "static/img/组 2848.4d8b67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2848.png
// module id = mXOd
// module chunks = 0